import { DialogRefEvents } from '@/shared/dialog/dialog-ref-events'
import { ID } from '@/shared/utils/id'

export class DialogRef<Output> {
  private _id: string = ID()

  get id(): string {
    return this._id
  }

  constructor(private events: DialogRefEvents<Output>) {}

  public close(): void {
    this.events.close()
  }

  public dismiss(): this {
    this.events.dismiss()

    return this
  }

  public submit(output: Output): this {
    this.events.submit(output)

    return this
  }
}
